<div class="teams_sec">

    <div class="container">
       
        <div class="content_sec">
            <span class="team_label"> TEAM </span>
            <h1>Meet the team who make UniBuild happen</h1>
            <p>We are a passionate group of professionals committed to bringing your ideas to life. With expertise in automotive design and a deep understanding of the manufacturing process, our team is here to guide you every step of the way. Get to know the experts who make innovation happen.</p>
        </div>


        <ul class="grid">
            <li *ngFor="let member of teamMembers">
                <figure>
                  <img [src]="member.image" [alt]="member.name" />
                </figure>
                <span class="name">{{ member.name }}</span>
                <span class="role">{{ member.role }}</span>
              </li>
        </ul>

        <div class="content_sec">
            <h2>Meet the team who make UniBuild happen</h2>
            <p>We're looking for passionate innovators. Ready to drive change? <br> Discover your next opportunity here!</p>
            <button class="view_btn" [routerLink]="'/career'" mat-button> View Open Position </button>
        </div>

    </div>


</div>
